import { PageTitle } from 'app/components/common/PageTitle'
import SchoolManagementContainer from 'app/containers/SchoolManagement'
import { isEqual } from 'lodash'
import { memo } from 'react'

const SchoolManagementCpn = () => {
  return (
    <>
      <PageTitle>{'Quản lý công đoàn bộ phận'}</PageTitle>
      <SchoolManagementContainer />
    </>
  )
}
export const SchoolManagementPage = memo(SchoolManagementCpn, isEqual)
